import { Expose } from "class-transformer";
import { ProductWithCmsData } from "../product-with-cms-data/product-with-cms-data.entity";
import type { IProductWithCmsDataAndQualification } from "./product-with-cms-data-and-qualification.entity.interface";

export class ProductWithCmsDataAndQualification
  extends ProductWithCmsData
  implements IProductWithCmsDataAndQualification
{
  @Expose()
  available!: boolean;
  @Expose()
  discountedPrice: number | undefined;
  @Expose()
  appliedDiscountCode: string | undefined;
  @Expose()
  isRequestable!: boolean;
  @Expose()
  isVisible!: boolean;
  @Expose()
  activeProcedureIdsByDescCreationOrder!: number[];
  @Expose()
  orderedTiersThatCanRequestProduct: string[] | undefined;

  @Expose()
  get isExpired(): boolean {
    const defaultFuturePubDate = "5000-01-01";
    const parsedPublicationDate = new Date(this.publicationDate ?? defaultFuturePubDate);
    const todayDate = new Date();
    return parsedPublicationDate > todayDate;
  }

  constructor(data?: IProductWithCmsDataAndQualification) {
    super();
    if (data) {
      Object.assign(this, data);
    }
  }
}
